<template>
  <div class="pb-3">
    <va-card :title="$t(`sendNotification.title`)">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(send)">
          <div class="row">
            <div class="flex md12">
              <ValidationProvider rules="required" name="Titulo da Mensagem" v-slot="{ errors }">
                <va-input
                  v-model="notificacao.title"
                  :label="$t('sendNotification.forms.titleLabel')"
                  :placeholder="$t('sendNotification.forms.titlePlaceholder')"
                  :success="errors.length == 0 && notificacao.title.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider rules="required" name="Corpo da Mensagem" v-slot="{ errors }">
                <va-input
                  v-model="notificacao.subtitle"
                  :label="$t('sendNotification.forms.bodyLabel')"
                  :placeholder="$t('sendNotification.forms.bodyPlaceholder')"
                  :success="errors.length == 0 && notificacao.subtitle.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <div v-if="imageUrl" class="form-group mb-2">
                <label>{{ $t('sendNotification.forms.imageLabel') }}</label>
                <div class="mt-1">
                  <img
                    :src="imageUrl"
                    alt="Preview do Sorteio"
                    style="max-width: 100%; max-height: 180px; border-radius: 6px; object-fit: cover; display: block; border: 1px solid #e0e0e0;"
                  />
                </div>
              </div>
            </div>
            <div class="d-flex mt-1">
              <va-button
                type="submit"
                :disabled="buttonSubmitDisabled"
                color="success"
                class="my-0">
                {{ textSubmit }}
              </va-button>
              <va-button
                type="button"
                class="my-0"
                color="danger"
                @click="cancel">
                {{ $t("forms.cancel") }}
              </va-button>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </va-card>
  </div>
</template>

<script>
export default {
  name: 'sendNotification',
  props: {
    sendData: {
      default: null,
    },
  },
  data () {
    return {
      notificacao: {
        title: '',
        subtitle: '',
        image: '',
      },
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.send'),
    }
  },
  computed: {
    imageUrl () {
      if (!this.notificacao || !this.notificacao.image) return ''
      if (this.notificacao.image.includes('http')) {
        return this.notificacao.image
      }
      const cdn = (this.$store.getters['environment/cdn'] || 'https://cdn.s1live.com').replace(/\/+$/, '')
      return `${cdn}/raffles/${this.notificacao.image}`
    },
  },
  mounted () {
    this.notificacao.title = ''
    this.notificacao.subtitle = ''
    this.notificacao.image = ''
    if (this.sendData !== null && this.sendData !== undefined) {
      if (this.sendData.name) {
        this.notificacao.title = this.sendData.name
      }
      if (this.sendData.image) {
        this.notificacao.image = this.sendData.image
      }
    }
  },
  methods: {
    cancel () {
      this.$emit('close', false)
    },
    send () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.sending')
      const self = this
      this.$axios.post(
        '/api/messaging/sorteio',
        {
          title: this.notificacao.title,
          body: this.notificacao.subtitle,
          image: this.notificacao.image,
        },
      ).then(response => {
        self.buttonSubmitDisabled = false
        self.textSubmit = self.$t('forms.send')
        self.$emit('close', false)
        self.showToast(
          self.$t('toasts.successSend'),
          {
            icon: 'fa-check',
            position: 'top-right',
            duration: 1000,
            fullWidth: false,
          },
        )
      })
        .catch(e => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.send')
          self.showToast(
            self.$t('toasts.errorSend'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
}
</script>
